import StyledModal from './StyledModal';

export * from './StyledModal';
export default StyledModal;
